module.exports = __webpack_public_path__ + "static/media/levels_5_1.558bd6cf.svg";